import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy } from "lucide-react";
import React, { useState } from "react";
import useProjectStore from "../store/projects";
import { maskApiKey } from "../utils/stringUtils";

const ApiKeyDisplay = ({ apiKey, onDone }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { openModal } = useProjectStore();

  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey);
    setIsCopied(true);

    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <>
      <div className="mt-4 text-md text-[gray] tracking-widest">
        Please save this API Key somewhere safe and accessible. For security
        reasons, you won't be able to view it again through your VizOps account.
        If you lose this API Key, you'll need to create a new one or regenerate
        it.
      </div>
      <div className="grid grid-cols-4 w-full items-center mt-4">
        <Input
          type="text"
          id="apiKey"
          placeholder="API Key"
          className={"col-span-3 font-mono text-md text-gray-500"}
          value={maskApiKey(apiKey)}
          readOnly
        />
        <Button
          variant={"borderless"}
          size="sm"
          className="text-md font-semibold ml-3"
          aria-label="Copy API Key"
          onClick={handleCopy}
        >
          {!isCopied ? <Copy className="size-10" /> : null}
          <span>{isCopied ? "Copied!" : "Copy"}</span>
        </Button>
      </div>
      <div className="flex justify-between w-full items-center mt-4">
        <Button
          variant="secondary"
          size="sm"
          className="text-md font-semibold"
          aria-label="Done"
          onClick={onDone}
        >
          <span>Done</span>
        </Button>
        <Button
          variant="primary"
          size="sm"
          className="text-md font-semibold"
          aria-label="Done"
          onClick={() => {
            openModal("collaborators");
            onDone();
          }}
        >
          <span>Add Collaborators</span>
        </Button>
      </div>
    </>
  );
};

export default ApiKeyDisplay;
